/**
 * Template: Blog
 * ------------------------------------------------------------------------------
 * Highly coupled scripts to power the blog page functionality.
 *
 * @namespace blog
 */
import { load } from '@shopify/theme-sections';
import '~/sections/blog-filters';
document.addEventListener('DOMContentLoaded', () => {
  load('*');
});